<ng-container *ngIf="customer">
  <h4><p class="text-center">{{customer.name}} bewerken</p></h4>

  <div class="card">
    <div class="card-block">
      <div class="row">
        <div class="col-md-6 col-xs-12">
          <div class="form-group row">
            <label class="col-form-label col-4">Naam</label>
            <div class="col-8">
              <input class="form-control" [(ngModel)]="customer.name" required="true" type="text">
              <pre class="alert alert-danger" *ngIf="error">{{error}}</pre>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-form-label col-4">Straat</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.street" type="text"></div>
          </div>

          <div class="form-group row">
            <label class="col-form-label col-4">Postcode</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.postal" type="text"></div>
          </div>

          <div class="form-group row">
            <label class="col-form-label col-4">Plaats</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.city" type="text"></div>
          </div>

          <div class="form-group row">
            <label class="col-form-label col-4">Telefoon</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.phonenumber" type="text"></div>
          </div>

          <div class="form-group row">
            <label class="col-form-label col-4">Email</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.email" type="text"></div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="form-group row">
            <label class="col-form-label col-4">Contactpersoon</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.contact" type="text"></div>
          </div>

          <div class="form-group row">
            <label class="col-form-label col-4">Contactpersoon telefoon</label>
            <div class="col-8"><input class="form-control" [(ngModel)]="customer.contactPhone" type="text"></div>
          </div>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="form-group row">
            <label class="col-form-label col-4">Notities</label>
            <div class="col-8"><textarea class="form-control" [(ngModel)]="customer.notes"></textarea></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row ui-toolbar">
    <div class="col-md-6">
      <button type="button" class="btn btn-primary" (click)="saveCustomer()">
        Opslaan
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="cancel()">
        Annuleren
      </button>
    </div>
  </div>
</ng-container>



// WEBPACK FOOTER //
// ./src/app/pages/customer/edit/customer.edit.component.html